export const setDefaultPaymentMethod = `mutation setDefaultPaymentMethod($paymentMethod: String!) {
  stripeSetupDefaultPaymentMethod(payment_method: $paymentMethod)
}`
